var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-modal',{ref:"modal",attrs:{"target":"root-modal","backfrop-styles":_vm.$options.backdropStyles,"close-on-backdrop-click":""}},[_c('div',{staticClass:"app-modal"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }